export const emptyAddress = {
  Country: '',
  City: '',
  StateOrProvince: '',
  Line1: '',
  Line2: '',
  PostalCode: '',
};

export const AblFormMode = {
  create: 0,
  update: 1,
  readonly: 2,
};

export const Forms = {
  AddressForm: 'AddressForm',
  BusinessName: 'BusinessName',
  BusinessAddressSelector: 'BusinessAddressSelector',
  CountrySelector: 'CountrySelector',
  CurrencySelector: 'CurrencySelector',
  PhoneNumber: 'PhoneNumber',
  TaxForm: 'TaxForm',
  TimeZone: 'TimeZone',
  UserLocation: 'UserLocation',
  UserAddressForm: 'UserAddressForm',
};

/*
By default, we only show forms which are strongly related to ABL.
For new additional forms, please set its default visibility to false.
*/
export const defaultFormControls = () => ({
  // strongly ABL-related forms, default visibility: true
  [Forms.AddressForm]: {
    visible: true,
    optional: false,
    disabled: false,
  },
  [Forms.BusinessName]: {
    visible: true,
    optional: false,
    disabled: false,
  },
  [Forms.BusinessAddressSelector]: {
    visible: true,
    optional: false,
    disabled: false,
  },
  [Forms.CountrySelector]: {
    visible: true,
    optional: false,
    disabled: false,
  },
  [Forms.TaxForm]: {
    visible: true,
    // TODO: support optional tax when backend supports
    optional: false,
    disabled: false,
  },
  // Additional forms, default visibility: false
  [Forms.CurrencySelector]: {
    visible: false,
    optional: false,
    disabled: false,
  },
  [Forms.PhoneNumber]: {
    visible: false,
    optional: false,
    disabled: false,
  },
  [Forms.TimeZone]: {
    visible: false,
    optional: false,
    disabled: false,
  },
  [Forms.UserLocation]: {
    visible: false,
    optional: false,
    disabled: false,
  },
  [Forms.UserAddressForm]: {
    visible: false,
    optional: false,
    disabled: false,
  },
});

export const fullOptionalFormControls = () => ({
  [Forms.AddressForm]: {
    optional: true,
  },
  [Forms.BusinessName]: {
    optional: true,
  },
  [Forms.BusinessAddressSelector]: {
    optional: true,
  },
  [Forms.CountrySelector]: {
    optional: true,
  },
  [Forms.TaxForm]: {
    optional: true,
  },
  [Forms.CurrencySelector]: {
    optional: true,
  },
  [Forms.PhoneNumber]: {
    optional: true,
  },
  [Forms.TimeZone]: {
    optional: true,
  },
});

export const defaultHelpPopupIds = i18n => ({
  [Forms.BusinessName]: {},
  [Forms.CountrySelector]: { ariaLabel: i18n.getString(_TL_('Business location tooltip')) },
  [Forms.BusinessAddressSelector]: { ariaLabel: i18n.getString(_TL_('Business address selector tooltip')) },
  [Forms.CurrencySelector]: { ariaLabel: i18n.getString(_TL_('Currency selector tooltip')) },
  [Forms.TimeZone]: { ariaLabel: i18n.getString(_TL_('Preferred time zone tooltip')) },
  [Forms.UserLocation]: { ariaLabel: i18n.getString(_TL_('User location tooltip')), popupId: 'pop_BA_Accounts_TST_UserLocation' },
});

export const AddressSelectorOptions = {
  enterNewAddressId: 0,
  selectExistingAddressId: -1,
};

export const defaultBusinessNameData = { businessName: '', isValid: false };
export const defaultPhoneNumberData = { phoneNumberWithCallingCode: '', isValid: false };
export const defaultTaxData = {
  data: [],
  taxCertification: {},
  isValid: false,
};

export const addressFormProperties = ['Country', 'Line1', 'Line2', 'Line3', 'Line4', 'StateOrProvince', 'City', 'PostalCode'];

export const mtValidationInfoProps = ['IsValid', 'ValidationVersionId'];

export const skipValidationResult = 'skipValidationResult';

const LogsPrefix = 'AccountBusinessLocation';
export const logsScenario = {
  Default: LogsPrefix,
  MoveForwardAfterValidation: `${LogsPrefix}_moveForwardAfterValidation`,
};
